import React from "react";


  const Pricing = ()=>{
      return(
        <>
          <p>Here are your Pricing message.</p>
        </>
      );
  }

  export default Pricing;
